import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Col, Row, Button } from 'reactstrap'
import CustomEditor from '../../../common/CustomEditor'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import CustomInput from '../../../common/InputGroup'
import { createComment } from '../../ClickToCall/Redux/clickToCallActions'

export default function CommentForm({ contactId }) {
  const [state, setState] = useState({
    subject: '',
    note: '',
  })

  const dispatch = useDispatch()

  const changeHandler = (e) => {
    const { name, value } = e.target
    setState((prev) => ({ ...prev, [name]: value }))
  }

  const editorChangeHandler = (e) => {
    setState((prev) => ({ ...prev, ['note']: e.htmlValue }))
  }

  const createCommentHandler = () => {
    dispatch(createComment(contactId, state))
  }

  const closeModalHandler = () => {
    dispatch(closeModal('comment_modal'))
  }

  return (
    <>
      <Row>
        <Col>
          <CustomInput
            type={'text'}
            name={'subject'}
            onChange={changeHandler}
            label={'Subject (optional)'}
            value={state.subject}
          />
        </Col>
      </Row>
      <Row className={'mt-5'}>
        <Col xs={12} md={12} lg={12}>
          <CustomEditor
            disableAttachmentButton
            onChange={editorChangeHandler}
            value={state.note}
            height={'250px'}
            customStyle={{ backgroundColor: 'none' }}
          />
        </Col>
      </Row>
      <Row className={'mt-3'}>
        <Col className={'d-flex justify-content-end align-items-center'}>
          <Button className={'btn-gold mr-3'} onClick={createCommentHandler}>
            Ok
          </Button>
          <Button className={'btn-gold'} onClick={closeModalHandler}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  )
}
